import { render, staticRenderFns } from "./FormProduct.vue?vue&type=template&id=1610dca0&scoped=true"
import script from "./FormProduct.vue?vue&type=script&lang=js"
export * from "./FormProduct.vue?vue&type=script&lang=js"
import style0 from "./FormProduct.vue?vue&type=style&index=0&id=1610dca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610dca0",
  null
  
)

export default component.exports